module.exports = __webpack_public_path__ + "images/directory/featured-hero/butler@2x.be5d25a792c86e9e6cc3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/butler@2x.png
// module id = 9VTl
// module chunks = 2